import { useState } from "react";
import SectionHeading from "./SectionHeading";
import { ratingDimensions, reviewAngles } from "@/mocks/movieContent";

export default function ReviewSection() {
  const [active, setActive] = useState(reviewAngles[0].id);

  return (
    <section id="review" className="scroll-mt-20 bg-background-50 py-16 md:py-24">
      <div className="w-full max-w-6xl mx-auto px-4 md:px-8">
        <SectionHeading
          eyebrow="影评解读"
          title="影评解读：从四个角度看这部电影"
          description="同一部影片，换个角度就会有新的发现。下面从主题、叙事、表演氛围和口碑四个角度分别展开，你可以自由切换查看。"
          icon="ri-chat-quote-line"
        />

        <div className="inline-flex flex-wrap gap-1 p-1 rounded-full bg-background-200 mb-8">
          {reviewAngles.map((angle) => (
            <button
              key={angle.id}
              type="button"
              onClick={() => setActive(angle.id)}
              className={`px-4 py-2 rounded-full text-sm whitespace-nowrap cursor-pointer transition-colors ${
                active === angle.id
                  ? "bg-primary-500 text-background-50 font-medium"
                  : "text-foreground-700 hover:text-foreground-950"
              }`}
            >
              {angle.label}
            </button>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-[1fr_320px] gap-8 lg:gap-12">
          <div>
            {reviewAngles.map((angle) => (
              <div key={angle.id} className={active === angle.id ? "block" : "hidden"}>
                <h3 className="font-heading text-xl md:text-2xl font-semibold text-foreground-950 leading-snug">
                  {angle.title}
                </h3>
                <div className="mt-4 space-y-4">
                  {angle.paragraphs.map((para) => (
                    <p key={para} className="text-sm md:text-base text-foreground-700 leading-relaxed">
                      {para}
                    </p>
                  ))}
                </div>
                <ul className="mt-6 grid grid-cols-1 sm:grid-cols-2 gap-3">
                  {angle.points.map((point) => (
                    <li
                      key={point}
                      className="flex items-start gap-2.5 rounded-lg border border-background-200 bg-background-100/60 px-4 py-3"
                    >
                      <i className="ri-checkbox-circle-line text-accent-600 mt-0.5"></i>
                      <span className="text-sm text-foreground-700 leading-relaxed">{point}</span>
                    </li>
                  ))}
                </ul>
              </div>
            ))}
          </div>

          <aside className="rounded-lg border border-background-200 bg-background-100/60 p-5 md:p-6 self-start">
            <div className="flex items-center gap-2">
              <span className="w-8 h-8 flex items-center justify-center rounded-md bg-accent-500 text-background-50">
                <i className="ri-bar-chart-2-line"></i>
              </span>
              <h3 className="font-heading text-base md:text-lg font-semibold text-foreground-950">观感维度参考</h3>
            </div>
            <p className="mt-3 text-xs text-foreground-500 leading-relaxed">
              以下为本页编辑视角的主观参考，并非任何平台的真实评分，仅供理解影片侧重时参考。
            </p>
            <div className="mt-5 space-y-4">
              {ratingDimensions.map((dim) => (
                <div key={dim.label}>
                  <div className="flex items-center justify-between text-xs md:text-sm">
                    <span className="text-foreground-700">{dim.label}</span>
                    <span className="text-foreground-500 font-label">{dim.value}</span>
                  </div>
                  <div className="mt-2 h-1.5 rounded-full bg-background-300">
                    <div
                      className="h-full rounded-full bg-primary-500"
                      style={{ width: `${dim.value}%` }}
                    ></div>
                  </div>
                </div>
              ))}
            </div>
          </aside>
        </div>
      </div>
    </section>
  );
}